import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2, Plus } from "lucide-react";
import api from "../../lib/api";
import { AdminHeader, Btn, DataTable, Card, Input, Localized } from "../../components/admin/Fields";
import ImageUpload from "../../components/admin/ImageUpload";

const empty = () => ({
  author_name: "",
  author_title: { tr: "", en: "", ar: "" },
  company: "",
  quote: { tr: "", en: "", ar: "" },
  portrait: "",
  featured: true,
  order: 0,
});

const AdminTestimonialsPage = () => {
  const [rows, setRows] = useState([]);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(empty());
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/admin/testimonials").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      const payload = { ...form, order: Number(form.order) || 0 };
      if (editing?.new) await api.post("/admin/testimonials", payload);
      else await api.put(`/admin/testimonials/${editing.id}`, payload);
      toast.success("Kaydedildi"); setEditing(null); load();
    } catch (err) { toast.error(err?.response?.data?.detail || err.message); } finally { setBusy(false); }
  };
  const remove = async (r) => {
    if (!window.confirm("Silinsin mi?")) return;
    await api.delete(`/admin/testimonials/${r.id}`); load();
  };

  if (editing) return (
    <div data-testid="admin-testimonial-form">
      <AdminHeader eyebrow="Trust" title={editing.new ? "Yeni Referans" : "Referansı Düzenle"}
        action={<div className="flex gap-3"><Btn variant="ghost" onClick={() => setEditing(null)}>İptal</Btn><Btn onClick={save} disabled={busy} testId="testimonial-save">Kaydet</Btn></div>} />
      <form onSubmit={save} className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 space-y-6">
          <Card title="Referans">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <Input label="Yazar Adı" value={form.author_name} onChange={(v) => setForm({ ...form, author_name: v })} testId="t-author" />
              <Input label="Şirket" value={form.company} onChange={(v) => setForm({ ...form, company: v })} />
              <Input label="Sıra" type="number" value={form.order} onChange={(v) => setForm({ ...form, order: v })} />
            </div>
            <div className="mt-6"><Localized label="Ünvan" value={form.author_title} onChange={(v) => setForm({ ...form, author_title: v })} /></div>
            <div className="mt-6"><Localized label="Yorum / Alıntı" value={form.quote} onChange={(v) => setForm({ ...form, quote: v })} textarea /></div>
          </Card>
        </div>
        <div className="space-y-6">
          <Card title="Portre"><ImageUpload label="Fotoğraf" value={form.portrait} onChange={(v) => setForm({ ...form, portrait: v })} /></Card>
          <Card title="Yayın">
            <label className="flex items-center gap-3 cursor-pointer">
              <input type="checkbox" checked={!!form.featured} onChange={(e) => setForm({ ...form, featured: e.target.checked })} />
              <span className="text-sm">Ana sayfada göster</span>
            </label>
          </Card>
        </div>
      </form>
    </div>
  );

  return (
    <div data-testid="admin-testimonials-page">
      <AdminHeader eyebrow="Trust" title="Referanslar" action={<Btn onClick={() => { setEditing({ new: true }); setForm(empty()); }} testId="new-testimonial"><Plus size={14} /> Yeni</Btn>} />
      <DataTable
        columns={[
          { key: "author_name", label: "Yazar" },
          { key: "company", label: "Şirket" },
          { key: "featured", label: "Öne Çıkan", render: (r) => r.featured ? "✓" : "" },
          { key: "actions", label: "", render: (r) => (
            <div className="flex justify-end gap-2">
              <Btn variant="ghost" onClick={() => { setEditing(r); setForm({ ...empty(), ...r }); }}>Düzenle</Btn>
              <Btn variant="danger" onClick={() => remove(r)}><Trash2 size={12} /></Btn>
            </div>
          ) },
        ]}
        rows={rows}
      />
    </div>
  );
};

export default AdminTestimonialsPage;
